import o from 'component-query';
import resolve from './resolve';

/**
 * Change head's title or restore with
 * one from config `organization name`
 *
 * @param {String} str
 * @api public
 */

export default function title(str, append, single) {
  o('head title').innerHTML = resolve(str, append, single);
}



// WEBPACK FOOTER //
// ./src/modules/title/title.js